import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { Submotive3Filters } from './filters';
import { Submotive3List } from './list';
import { SUBMOTIVE3, SUBMOTIVE3_NEW } from '../../../../routes/paths';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import { Param } from '../../../../shared/types/param';

export const Submotive3 = () => {
    const [filters, setFilters] = useState<Param>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de submotivo 3"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBMOTIVE3_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBMOTIVE3,
                        }}
                    />
                }
            >
                <Submotive3Filters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <Submotive3List filters={filters} />
        </>
    );
};
